export const requiredMessage = (fieldName: string) => `${fieldName} is required`
export const numericMessage = (fieldName: string) => `${fieldName} must be numeric`
export const stringMessage = (fieldName: string) => `${fieldName} must be alpha-numeric`
export const integerMessage = (fieldName: string) => `${fieldName} must be an integer`
export const booleanMessage = (fieldName: string) => `${fieldName} must be a boolean`
export const newlineMessage = (fieldName: string) => `${fieldName} may not contain newline characters`
export const stringSizeMaxMessage = (fieldName: string, maxSize: number) =>
    `${fieldName} must contain at most ${maxSize} characters`
export const stringSizeMinMessage = (fieldName: string, minSize: number) =>
    `${fieldName} must contain at least ${minSize} characters`
export const stringSizeBetweenMessage = (fieldName: string, minSize: number, maxSize: number) =>
    `${fieldName} must be between ${minSize} and ${maxSize} characters`
export const nonNegativeMessage = (fieldName: string) => `${fieldName} must be be greater than or equal to 0`
export const maxNumberMessage = (fieldName: string, maxValue: number) =>
    `${fieldName} must be less than or equal to ${maxValue}`
export const durationMessage = () => `Duration Must Be In Format XX:XX`
